import { Component, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Camera } from 'app/cameras/models';
import { AppState } from 'app/store/model';
import { Subscription, filter } from 'rxjs';
import { UserActions } from '../Services/actions';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ValidationResponseHandlerModule } from 'app/Shared/ValidationResponse/validation-response-handler';
import { CreateHolidayRequest, Holidays, NationalHolidays, UserHolidays} from '../models';
import { formatDate } from '@angular/common';
import { calendarParser } from 'app/Shared/Parsers/calendar-parser';
import { format as formatDateFns, parseISO } from 'date-fns';
import { SharedService } from 'app/Shared/Services/shared.service';
import { ResultAlert } from 'app/Shared/models';


@Component({
    selector: 'app-user-calendar-create',
    templateUrl: './user-calendar-create.component.html',
    styleUrl: './user-calendar-create.component.scss',
    standalone: false
})
export class UserCalendarCreateComponent implements OnInit, OnDestroy {
    @Output() modalClose = new EventEmitter<string>();

    readonly cameras$ = this.store.select((state: AppState) => state.camera.cameras);
    readonly nationalHolidays$ = this.store.select((state: AppState) => state.Users.nationalHolidays);
    readonly createCalendar$ = this.store.select((state: AppState) => state.Users.holidays);
    readonly updateCalendar$ = this.store.select((state: AppState) => state.Users.holidays);

    nationalHolidaysSub: Subscription;
    subSelectWholeDay: Subscription;
    createCalendarSub: Subscription;
    updateCalendarSub: Subscription;
    calendarSub: Subscription;
    swalDecisionSub: Subscription;

    clientName: string;
    user_sub: string;
    child_sub: string;
    holidays: Holidays[];
    allHolidaysData: Holidays[];

    dateRange = [];
    rangeForm = new UntypedFormGroup({
        start: new UntypedFormControl(''),
        end: new UntypedFormControl('')
    });
    selectWholeDay = new UntypedFormControl('', [Validators.required]);

    elementsHoliday: Holidays[] = [
        {
            alias: '',
            start_time: '',
            end_time: '',
            beginTime: '',
            endTime: '',
            foreignhash: '',
            cameras_id: [],
            national_holiday: false,
            to_all_cameras_user: undefined,
            active: true,
            id: 1
        },
    ];

    newHolidaysElement: Holidays = {
        alias: '',
        start_time: '',
        end_time: '',
        beginTime: '',
        endTime: '',
        foreignhash: '',
        cameras_id: [],
        national_holiday: false,
        to_all_cameras_user: undefined,
        active: true,
        id: 2
    };

    holidayName: any;
    beginTime: string;
    endTime: string;
    errorTime: boolean;

    cameras: Camera[];
    cameraList: {
        id: number | string;
        text: string;
        qtdAnl: number;
    }[];

    currentTime = new Date();
    showTime: boolean[] = new Array(50).map(x => false);
    uniqueTime = false;
    loadingHolidayList: boolean;
    loadingCameras: boolean;
    loadingNationalHolidayList: boolean;
    restoreHolidays: boolean;
    cleanHolidays: boolean;
    creatingCalendar: boolean;
    updatingCalendar: boolean;
    errorPass: boolean;
    allDayChecked: boolean;
    holidayCams: any;
    modalEdit: boolean;
    modalCreate: boolean;
    weAvaError: boolean;
    analyticVerified = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private readonly store: Store<AppState>, private validationResponse: ValidationResponseHandlerModule, private service: SharedService) { }

    ngOnInit(): void {
        this.dateRange = [];
        this.loadingHolidayList = true;
        this.loadingCameras = true;
        this.clientName = this.data.data.client_name;
        this.cameras = this.data.data.cameras;
        this.user_sub = localStorage.getItem('sub');
        this.child_sub = localStorage.getItem('clientView');
        this.modalEdit = localStorage.getItem('tipoModal') == 'edit';
        this.modalCreate = localStorage.getItem('tipoModal') == 'create';
        this.errorPass = true;
        this.getAllHolidays();
        this.getAllHolidaysResult();
        this.selectWholeDays();
        this.getCameras();
        this.cleanHolidays = true;
        if (this.allHolidaysData == undefined || this.allHolidaysData.length == 0) {
            this.loadingNationalHolidayList = this.modalCreate;
            this.getNationalHolidays();
            this.getNationalHolidaysResult(false);
            this.restoreHolidays = false;
        }
        this.swalDecisionSub = this.service.swalDecision.subscribe(returnSwallObject => {
            if (returnSwallObject) {
                this.validateReturnMethodCalled(returnSwallObject as ResultAlert);
            }
        });
    }

    closeModal() {
        this.modalClose.emit();
        this.store.dispatch(UserActions.cleanup());
        this.getAllHolidays();
    }

    ngOnDestroy() {
        if (this.nationalHolidaysSub) {
            this.nationalHolidaysSub.unsubscribe();
        }
        if (this.subSelectWholeDay) {
            this.subSelectWholeDay.unsubscribe();
        }
        if (this.createCalendarSub) {
            this.createCalendarSub.unsubscribe();
        }
        if (this.calendarSub) {
            this.calendarSub.unsubscribe();
        }
        if (this.updateCalendarSub) {
            this.updateCalendarSub.unsubscribe();
        }
        if (this.swalDecisionSub) {
            this.swalDecisionSub.unsubscribe();
        }

        this.elementsHoliday = [{alias: '', start_time: '', end_time: '', beginTime: '', endTime: '', foreignhash: '', cameras_id: [], national_holiday: false, to_all_cameras_user: undefined, active: true, id: 1}];
        this.closeModal();
        this.store.dispatch(UserActions.cleanup());
        this.store.dispatch(UserActions.get_calendar_list_clear());
        this.store.dispatch(UserActions.get_national_holidays_clear());
    }

    getCameras() {
        this.loadingCameras = false;
        if (this.cameras?.length > 0) {
            this.cameraList = this.cameras.map(element => {
                return {
                    id: element.id,
                    text: element.alias,
                    qtdAnl: element.analytics
                };
            });
        }
    }

    getTime(start, end) {
        if (start && /^\d{2}:\d{2}$/.test(start) && end && /^\d{2}:\d{2}$/.test(end) ) {
            this.setTime([start, end]);
        }
    }

    setTime(newItem: [string, string], id?: number) {
        const list = this.allHolidaysData.length > 0 ? this.allHolidaysData : this.elementsHoliday;
        // Garantir que está no formato HH:mm
        const formatTime = (t: string, suffix: string): string => {
            if (!t || !t.includes(':')) {return null; }
            return `${t}:${suffix}`;
        };
        let newStartTime = formatTime(newItem[0], '00');
        let newEndTime = formatTime(newItem[1], '59');
        const updateTimes = (holiday) => {
            if (!newItem[0] && !newItem[1]) {
                newStartTime = newEndTime = null;
                this.beginTime = this.endTime = null;
                holiday.beginTime = holiday.endTime = null;
            } else {
                holiday.beginTime = newStartTime;
                holiday.endTime = newEndTime;
            }
        };

        if (id !== undefined && id >= 0) {
            this.uniqueTime = true;
            updateTimes(list[id]);
        } else {
            this.uniqueTime = false;
            list.forEach(updateTimes);
            this.beginTime = newStartTime;
            this.endTime = newEndTime;
        }
    }

    getAllHolidays() {
        this.store.dispatch(UserActions.get_calendar_list({
            user_sub: this.user_sub,
            child_sub: this.child_sub,
        }));
    }

    getAllHolidaysResult() {
        this.calendarSub =  this.store.select((state: AppState) => state.Users.calendarList).pipe(filter((value) => !!value)).subscribe(result => {
            if (result) {
                this.loadingHolidayList = false;
                if (result.status === 2) {
                    this.allHolidaysData = calendarParser(result.data as UserHolidays[], 'user');
                    if (this.allHolidaysData.length > 0) {
                        this.allHolidaysData = this.transformHolidays(this.allHolidaysData);
                    }
                }
                else {
                    this.validationResponse.validationResponseHandler(400, 'user', 'calendar-result-fail', 'user.calendar-result-fail');
                }
            }
        });
    }

    getNationalHolidays() {
        this.store.dispatch(UserActions.get_national_holidays({
            user_sub: this.user_sub,
        }));
    }

    getNationalHolidaysResult(restore?: boolean) {
        this.nationalHolidaysSub = this.nationalHolidays$.subscribe(result => {
            if (result) {
                if (result.status === 2) {
                    this.loadingHolidayList = false;
                    this.elementsHoliday = calendarParser(result.data as NationalHolidays[], 'national');
                    this.elementsHoliday = this.transformHolidays(this.elementsHoliday, 'national', restore);
                    if (this.elementsHoliday.length > 0) {
                        if (restore == true) {
                            this.allHolidaysData = this.allHolidaysData.concat(this.elementsHoliday);
                        }
                    }
                    this.loadingNationalHolidayList = false;
                }
                else {
                    this.loadingNationalHolidayList = false;
                    this.validationResponse.validationResponseHandler(400, 'user', 'calendar-result-fail', 'user.calendar-result-fail');
                    // this.store.dispatch(UserActions.get_national_holidays_clear());
                }
            }
        });
    }

    adjustDate(dateString) {
        const dateHour = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
        if (dateHour.test(dateString)) {
            if (!dateString) {
                return null;
            }
            const [datePart, timePart] = dateString.split(' ');
            const [year, month, day] = datePart.split('-').map(Number);
            const [hour, minute, second] = timePart.split(':').map(Number);

            const date = new Date(year, month - 1, day, hour, minute, second);

            return date;
        }
        else {
            if (!dateString) {
                return null;
            }
            const date = new Date(dateString);
            const userTimezoneOffset = date.getTimezoneOffset() * 60000;
            const correctedDate = new Date(date.getTime() + userTimezoneOffset);
            return correctedDate;
        }
    }

    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        this.dateRange[0] = dateRangeStart.value;
        this.dateRange[1] = dateRangeEnd.value;
    }

    openTimePicker(id) {
        this.showTime[id] = true;
        const tooltip = document.querySelector(`#tooltip-time-${id}`) as HTMLElement;
        const tooltipIcon = document.querySelector(`#tooltip-icon-${id}`) as HTMLElement;
        if (tooltip.style.visibility == '' || tooltip.style.visibility == 'hidden') {
            tooltip.style.visibility = 'visible';
            tooltipIcon.style.backgroundColor = '#6CACFF';
            tooltipIcon.style.color = '#FFFF';
        }
    }

    closeTimePicker(id) {
        this.showTime[id] = false;
        const tooltip = document.querySelector(`#tooltip-time-${id}`) as HTMLElement;
        const tooltipIcon = document.querySelector(`#tooltip-icon-${id}`) as HTMLElement;

        if (tooltip && tooltipIcon && tooltip.style.visibility === 'visible') {
            tooltip.style.visibility = 'hidden';
            tooltipIcon.style.backgroundColor = '#FFFF';
            tooltipIcon.style.color = '#306EBF';
        }

        const list = this.allHolidaysData && this.allHolidaysData.length > 0 ? this.allHolidaysData : this.elementsHoliday;
        if (id >= 0 && id < list.length) {
            const holiday = list[id];
            if (holiday.beginTime != this.beginTime || holiday.endTime != this.endTime) {
                this.uniqueTime = true;
            }
        }
    }

    cleanNationalHolidays() {
        this.restoreHolidays = true;
        this.cleanHolidays = false;
        this.elementsHoliday = this.elementsHoliday.filter(element => element.national_holiday !== true);
        if (this.allHolidaysData.length > 0){
            this.allHolidaysData = this.allHolidaysData.filter(element => element.national_holiday !== true);
        }
        if (this.elementsHoliday.length == 0 && this.allHolidaysData.length == 0) {
            this.newHolidays();
        }
    }

    restoreNationalHolidays() {
        if (this.nationalHolidaysSub) {
            this.nationalHolidaysSub.unsubscribe();
        }
        this.getNationalHolidays();
        this.getNationalHolidaysResult(true);
        this.loadingHolidayList = true;
        this.restoreHolidays = false;
        this.cleanHolidays = true;
    }

    newHolidays() {
        const newHoliday = { alias: this.newHolidaysElement.alias, start_time: this.newHolidaysElement.start_time, end_time: this.newHolidaysElement.end_time,
            beginTime: this.beginTime != undefined ? this.beginTime : this.newHolidaysElement.beginTime, endTime: this.endTime != undefined ? this.endTime : this.newHolidaysElement.endTime, foreignhash: this.newHolidaysElement.foreignhash, cameras_id: this.newHolidaysElement.cameras_id,
            national_holiday: this.newHolidaysElement.national_holiday, to_all_cameras_user: this.newHolidaysElement.to_all_cameras_user, active: this.newHolidaysElement.active,
            id: this.newHolidaysElement.id};

        if (this.allHolidaysData.length > 0) {
            this.allHolidaysData = [...this.allHolidaysData, newHoliday];
            this.newHolidaysElement.id = this.allHolidaysData.length + 1;
        } else {
            this.elementsHoliday = [...this.elementsHoliday, newHoliday];
            this.newHolidaysElement.id = this.elementsHoliday.length + 1;
        }
    }

    removeHoliday(id) {
        if (this.allHolidaysData.length > 0) {
            this.allHolidaysData.splice(id, 1);
            this.allHolidaysData = [...this.allHolidaysData];
            if (this.allHolidaysData[id]?.national_holiday === true) {
                this.restoreHolidays = true;
            }
        }
        else {
            this.elementsHoliday.splice(id, 1);
            this.elementsHoliday = [...this.elementsHoliday];
            if (this.elementsHoliday[id]?.national_holiday === true) {
                this.restoreHolidays = true;
            }
        }
    }

    selectWholeDays() {
        if (this.beginTime == '00:00:00' && this.endTime == '23:59:59') {
            this.allDayChecked = true;
            this.selectWholeDay.setValue(this.allDayChecked);
        }
        else {
            this.allDayChecked = false;
            this.selectWholeDay.setValue(this.allDayChecked);
        }
        this.subSelectWholeDay = this.selectWholeDay.valueChanges.subscribe(monitoring => {
            if (monitoring) {
                this.beginTime = '00:00';
                this.endTime = '23:59';
            } else {
                this.beginTime = '';
                this.endTime = '';
            }
            this.setTime([this.beginTime, this.endTime]);
        });
    }

    personalizedHourButton(id: number) {
        const list = this.allHolidaysData?.length > 0 ? this.allHolidaysData : this.elementsHoliday;
        if (id < 0 || id >= list.length) {
            return false;
        }
        const holiday = list[id];
        const hasCustomTime = (holiday.beginTime && holiday.beginTime !== '00:00:00' && holiday.beginTime !== this.beginTime) ||
                              (holiday.endTime && holiday.endTime !== '23:59:59' && holiday.endTime !== this.endTime);
        return this.allHolidaysData?.length > 0 ? hasCustomTime : hasCustomTime && this.uniqueTime;
    }


    getHolidayHour(id: number) {
        const list = this.allHolidaysData && this.allHolidaysData.length > 0 ? this.allHolidaysData : this.elementsHoliday;
        if (id >= 0 && id < list.length) {
            const holiday = list[id];

            if (holiday.beginTime == null && holiday.endTime == null) {
                return '';
            }
            if (holiday.beginTime == '00:00:00' && holiday.endTime == '23:59:59') {
                return '24 horas';
            }
            if (this.uniqueTime) {
                return holiday.beginTime ? `${holiday.beginTime} - ${holiday.endTime}` : '';
            }
            if (holiday.beginTime == '' && holiday.endTime == '') {
                return '';
            }
            return `${holiday.beginTime} - ${holiday.endTime}`;
        }
    }

    getHolidayName(event, i) {
        if (this.allHolidaysData.length > 0) {
            this.allHolidaysData[i].alias = event;
        }
        else {
            if (this.elementsHoliday[i] != undefined) {
                this.elementsHoliday[i].alias = event;
            }
        }
    }

    changeCams(event, i: number) {
        if (this.allHolidaysData.length > 0) {
            this.allHolidaysData[i].cameras_id = event ;
        } else {
            if (this.elementsHoliday[i] != undefined) {
                this.elementsHoliday[i].cameras_id = event;
            }
        }
    }

    isEmpty(holidays) {
        for (const holiday of holidays) {
            if (holidays[1] != holidays[4] || holidays[2] != holidays[5]) {
                if ((holidays[1] === undefined && holidays[2] === undefined) && (holidays[4] !== undefined
                    && holidays[4] !== '' && holidays[5] !== undefined && holidays[5] !== '')) {
                    this.errorPass = true;
                    this.updatingCalendar = true;
                    return;
                }
                else if ((holidays[1] === undefined && holidays[2] === undefined) && (holidays[4] === undefined
                        || holidays[4] === '' || holidays[5] === undefined || holidays[5] === '')) {
                    this.errorPass = false;
                    this.updatingCalendar = false;
                    return;
                }
            } else if (holiday === '' || holiday === undefined) {
                this.errorPass = false;
                this.updatingCalendar = false;
                return;
            }
        }

        this.errorPass = true;
        this.updatingCalendar = true;
    }

    cameraPlaceholder(holiday) {
        if (this.allHolidaysData?.length === 0) {
            if (holiday.national_holiday) {
                return 'Todas as câmeras';
            } else {
                return 'Selecionar câmera(s)';
            }
        } else if (this.allHolidaysData?.length > 0) {
            if (holiday.to_all_cameras_user === true) {
                return 'Todas as câmeras';
            }
            if (!holiday.id_cameras) {
                if (holiday.cameras_info && holiday.to_all_cameras_user === false && holiday.cameras_info.length > 0) {
                    return holiday.cameras_info[0]?.alias;
                }
                else {
                    return 'Selecionar câmera(s)';
                }
            }
            else {
                return 'Selecionar câmera(s)';
            }
        } else {
            return 'Selecionar câmera(s)';
        }
    }

    cameraSelect(holiday) {
        if (this.allHolidaysData?.length === 0) {
            if (holiday.national_holiday === true || holiday.type === 'national') {
                return this.cameraList;
            } else {
                return '';
            }
        } else if (this.allHolidaysData?.length > 0) {
            if (holiday.to_all_cameras_user === true) {
                return this.cameraList;
            } else if (holiday && holiday.to_all_cameras_user === false && holiday.cameras_info) {
                return holiday.cameras_info;
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    formateData(date) {
        if (date != undefined) {
            const [day, month, year] = date.split('/');
            return `${year}-${month}-${day}`;
        } else {
            return null;
        }
    }

    formatHour(hour: string): string {
        if (!hour) {
            return null;
        }
        if (/^\d{2}:\d{2}:\d{2}$/.test(hour)) {
            return hour;
        } else if (/^\d{2}:\d{2}$/.test(hour)) {
            return `${hour}:00`;
        } else {
            return hour.slice(0, 2) + ':' + hour.slice(2) + ':00';
        }
    }

    transformHolidays(holidays: Holidays[], type?: string, restore?: boolean): Holidays[] {
        if (type === 'create' || type === 'update') {
            this.errorTime = !holidays.some(holiday => holiday.beginTime || holiday.endTime);
        }

        if (this.errorTime && (type === 'create' || type === 'update')) {
            this.errorPass = false;
            return [];
        }

        return holidays.map(holiday => this.transformByType(holiday, type, restore)).filter(Boolean);
    }

    private transformByType(holiday: Holidays, type?: string, restore?: boolean): any {
        const holidayCams = holiday.cameras_id;

        if ((type === 'create' || type === 'update') && !holiday.beginTime && !holiday.endTime) {
            this.errorPass = false;
            return null;
        }
        if (holiday.beginTime && holiday.endTime && (!holiday.alias || !holidayCams || !holiday.date_begin)) {
            this.errorPass = false;
            return null;
        }

        const isAllDay = holiday.beginTime === '00:00:00' && holiday.endTime === '23:59:59';

        if (type === 'national') {
            const startDate = this.formatDateWithTime(holiday.start_time, holiday.beginTime);
            const endDate = holiday.end_time ? this.formatDateWithTime(holiday.end_time, holiday.endTime) : null;

            return {
                alias: holiday.alias ?? 'Confraternização Universal',
                date_begin: this.adjustDate(startDate),
                date_end: this.adjustDate(endDate),
                beginTime: this.beginTime,
                endTime: this.endTime,
                national_holiday: holiday.national_holiday,
                active: true,
                all_day: isAllDay,
                to_all_cameras_user: true,
                cameras_id: holidayCams,
                ...(restore && { start_time: startDate, end_time: endDate })
            };
        }

        if (type === 'update') {
            holiday.start_time = formatDateFns((holiday.date_begin ? holiday.date_begin : parseISO(holiday.start_time)), 'yyyy-MM-dd');
            holiday.end_time = formatDateFns((holiday.date_end ? holiday.date_end : holiday.end_time ? parseISO(holiday.start_time) : parseISO(holiday.start_time)), 'yyyy-MM-dd');

            const startDate = this.formatDateWithTime(holiday.start_time, this.formatHour(holiday.beginTime), 'T');
            const endDate = this.formatDateWithTime(holiday.end_time || holiday.start_time, this.formatHour(holiday.endTime), 'T');

            this.isEmpty.call(this, [
                holiday.alias,
                this.beginTime,
                this.endTime,
                holiday.start_time,
                holiday.beginTime,
                holiday.endTime,
                holiday.end_time,
                holidayCams?.length === 0 ? '' : 'notEmpty'
            ]);

            return {
                alias: holiday.alias,
                start_time: startDate,
                end_time: endDate,
                national_holiday: !!holiday.national_holiday,
                active: holiday.active,
                all_day: startDate.split('T')[1] === '00:00:00' && endDate.split('T')[1] === '23:59:59',
                to_all_cameras_user: this.cameras.length === holidayCams?.length,
                cameras_id: holidayCams?.map((el: any) => typeof el === 'number' ? el : el.id),
                hash_holiday: holiday.hash_holiday || ''
            };
        }

        if (type === 'create') {
            holiday.start_time = formatDateFns((holiday.date_begin ?? parseISO(holiday.start_time)), 'yyyy-MM-dd');
            holiday.end_time = formatDateFns((holiday.date_end ?? parseISO(holiday.start_time)), 'yyyy-MM-dd');

            const startDate = this.formatDateWithTime(holiday.start_time, this.formatHour(holiday.beginTime), 'T');
            const endDate = this.formatDateWithTime(holiday.end_time, this.formatHour(holiday.endTime), 'T');

            this.isEmpty.call(this, [
                holiday.alias,
                this.beginTime,
                this.endTime,
                holiday.start_time,
                holiday.beginTime,
                holiday.endTime,
                holiday.end_time,
                holidayCams?.length === 0 ? '' : 'notEmpty'
            ]);

            return {
                alias: holiday.alias,
                start_time: startDate,
                end_time: endDate,
                national_holiday: !!holiday.national_holiday,
                active: true,
                all_day: startDate.split('T')[1] === '00:00:00' && endDate.split('T')[1] === '23:59:59',
                to_all_cameras_user: this.cameras.length === holidayCams?.length,
                id_cameras: holidayCams || []
            } as CreateHolidayRequest;
        }

        // default (restore visualization)
        const [startDateRaw, startTime] = holiday.start_time.split('T');
        const [endDateRaw, endTime] = holiday.end_time.split('T');

        holiday.start_time = startDateRaw;
        holiday.end_time = endDateRaw;
        holiday.beginTime = startTime;
        holiday.endTime = endTime;

        const dateBegin = this.adjustDate(this.formatDateWithTime(startDateRaw, startTime));
        const dateEnd = this.adjustDate(this.formatDateWithTime(endDateRaw, endTime));

        return {
            ...holiday,
            date_begin: dateBegin,
            date_end: dateEnd
        };
    }

    private formatDateWithTime(date: string, time?: string, separator = ' '): string {
        return formatDate(date, 'yyyy-MM-dd', 'pt') + (time ? `${separator}${time}` : '');
    }

    validateReturnMethodCalled(returnResultSwal: ResultAlert) {
        if (returnResultSwal.methodCalled === 'calendarWOAnalytics') {
            if (returnResultSwal.isDismissed) {
                this.analyticVerified = true;
                if (this.modalCreate) {
                    this.createCalendar();
                } else {
                    this.updateCalendar();
                }
            }
        }
    }

    verifyAnalytics(holidays, cameras): boolean {
        if (this.analyticVerified) {return true; }
        for (const holiday of holidays) {
            for (const idCamera of (this.modalCreate ? holiday.id_cameras : holiday.cameras_id)) {
                const camera = cameras.find(cam => cam.id === idCamera);
                if (camera && camera.qtdAnl === 0) {
                    this.validationResponse.validationResponseHandler(200, 'user-calendar', 'without-analytics');
                    return false;
                }
            }
        }
        return true;
    }


    createCalendar() {
        this.creatingCalendar = true;
        const transformedHolidays: Holidays[]  = this.transformHolidays(this.elementsHoliday, 'create');
        if (!this.errorPass) {
            this.creatingCalendar = false;
            this.analyticVerified = false;
            return;
        }

        if (!this.verifyAnalytics(transformedHolidays, this.cameraList)) {
            this.creatingCalendar = false;
            return;
        }

        this.store.dispatch(UserActions.create_calendar({
            user_sub: this.user_sub,
            child_sub: this.child_sub,
            holidays: transformedHolidays
        }));

        this.createCalendarResult();
    }

    createCalendarResult() {
        this.createCalendarSub = this.createCalendar$.subscribe(result => {
            if (result) {
                this.creatingCalendar = false;
                if (result.status === 3) {
                    this.validationResponse.validationResponseHandler(400, 'user', 'calendar-create-fail', 'user.calendar-create-fail');
                    this.analyticVerified = false;
                }
                if (result.status === 0) {
                    this.validationResponse.validationResponseHandler(204, 'user', 'calendar-create-warning', result.message);
                    this.analyticVerified = false;
                }
                if (result.status === 2) {
                    this.validationResponse.validationResponseHandler(200, 'user', 'calendar-create-success', 'user.calendar-create-success');
                    this.closeModal();
                }
                this.store.dispatch(UserActions.create_calendar_clear());
            }
        });
    }

    updateCalendar() {
        this.updatingCalendar = true;
        const transformedHolidays: Holidays[]  = this.transformHolidays(this.allHolidaysData, 'update');

        if (!this.errorPass) {
            this.updatingCalendar = false;
            this.analyticVerified = false;
            return;
        }

        if (!this.verifyAnalytics(transformedHolidays, this.cameraList)) {
            this.updatingCalendar = false;
            return;
        }

        this.store.dispatch(UserActions.update_calendar({
            user_sub: this.user_sub,
            child_sub: this.child_sub,
            holidays: transformedHolidays
        }));
        this.updateCalendarResult();
    }

    updateCalendarResult() {
        this.updateCalendarSub = this.updateCalendar$.subscribe(result => {
            if (result) {
                this.updatingCalendar = false;
                if (result.status === 2) {
                    this.weAvaError = false;
                    this.validationResponse.validationResponseHandler(200, 'user', 'calendar-update-success', 'user.calendar-update-success');
                    this.store.dispatch(UserActions.update_calendar_clear());
                    this.closeModal();
                }
                else {
                    this.weAvaError = true;
                    this.analyticVerified = false;
                    if (result.statusCode == 403) {
                        this.validationResponse.validationResponseHandler(403, 'user', 'calendar-update-hashname-fail', result.message);
                        this.store.dispatch(UserActions.update_calendar_clear());
                    }
                    else {
                        this.validationResponse.validationResponseHandler(400, 'user', 'calendar-update-fail', 'user.calendar-update-fail');
                        this.store.dispatch(UserActions.update_calendar_clear());
                    }
                }
            }
        });
    }

    getFullYear(): Date {
        const currentYear = new Date().getFullYear();
        return new Date(currentYear, 0, 1);
    }

}
